import ConstructUpload from './ConstructUpload';
import Design from './Design';

export { ConstructUpload };
export default Design;
